
export class CategoryParamModel {
    id: string;
    categoryTypeId: number;
    operationTypeId: number;
    name: string;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/eldm-param-value/entities/category-param-model.ts